import React, { useMemo } from 'react';
import Range from '@alltrails/shared/components/Range';
import { formattedStepForIndex, getSliderValues } from 'utils/slider';
import { FilterConfigSlider } from 'types/Search';
import { SearchFiltersUtil } from 'utils/search_filters_util';

export type RangeGroupProps = {
  config: FilterConfigSlider;
  handler: (changes: FilterConfigSlider) => void;
};

const onChange = (changes: [number, number], config: FilterConfigSlider): FilterConfigSlider => {
  const updates = getSliderValues(changes, config);

  return {
    ...config,
    displayValue: updates.displayRange,
    value: updates.convertedRange,
    formattedRange: updates.formattedRange
  };
};

const RangeGroup = ({ config, handler }: RangeGroupProps) => {
  const displayFunction = SearchFiltersUtil.getFilterDisplayFunction(config.displayFunction);

  const inclusiveRangeMax = config.initialRange[1] + 1;

  const { upperBound, stepIncreaseAt, stepIncreaseBy } = config;

  const options = useMemo(
    () =>
      [...Array(inclusiveRangeMax)].map((_, index: number) => ({
        label: displayFunction(formattedStepForIndex({ index, stepIncreaseAt, upperBound, stepIncreaseBy }))
      })),
    [inclusiveRangeMax, displayFunction, upperBound, stepIncreaseAt, stepIncreaseBy]
  );

  const min = config.displayValue[0];
  const max = config.displayValue[1] === -1 ? options.length - 1 : config.displayValue[1];

  return <Range values={[min, max]} options={options} onChange={(changes: [number, number]) => handler(onChange(changes, config))} />;
};

export default RangeGroup;
